import { render, staticRenderFns } from "./PagesCountEconomistView.vue?vue&type=template&id=391123d4&scoped=true"
import script from "./PagesCountEconomistView.vue?vue&type=script&lang=js"
export * from "./PagesCountEconomistView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391123d4",
  null
  
)

export default component.exports